export const TRANSACTION_ACCOUNT_WITHOUT_BALANCE = {
    id: 'TRA_123_456_789_123',
    accountNumber: '2041001006',
    customerId: 'BAC_111_112_361_487',
    distributorId: 'Raisin',
    balance: null,
    state: 'ACTIVE',
    iban: 'DE45100500006179680191',
    bic: 'BARCGB22',
    currencyCode: 'EUR',
    referenceAccountId: '200594200594',
    sortCode: '23141241312',
    createdDate: '2016-09-06T13:37:50+03:00',
    lastStateUpdate: '2016-09-06T13:37:50+03:00',
    isMaintenance: false,
};
export const TRANSACTION_ACCOUNT_WITH_BALANCE = Object.assign(Object.assign({}, TRANSACTION_ACCOUNT_WITHOUT_BALANCE), { balance: {
        current: 500000.0,
        available: 100000.0,
        reserved: 10000.01,
    } });
//# sourceMappingURL=transaction-account.js.map